import React, {useMemo, useState} from "react";
import {Space, Spin, Tooltip} from "antd";
import {TagPreview} from "../../ExploreResults";
import HierarchyNode, {ObjectReferenceWithExtraData} from "../../ImageViewerHandlers/Hierarchy/HierarchyNode";
import {ViewHierarchy} from "./ViewHierarchy";
import {useFetchWithLoading} from "../../../hooks/useFetch";
import {empty} from "../../../Utilities";
import {SelectReferenceToGoModal} from "./SelectReferenceToGoModal";
import {AsyncDataSource} from "../../Misc/Table/ManualPagedTable";


function ObjectReferenceV2Component({reference, node, hierarchyView}: {
    node: HierarchyNode,
    hierarchyView: ViewHierarchy,
    reference: ObjectReferenceWithExtraData
}) {
    const tagReference = reference.tag_reference;

    const tooltipContent = (
        <TagPreview
            resultId={tagReference.result_reference.result_id}
            isFinalResult={tagReference.result_reference.is_final}
            tagNumber={tagReference.tag_number}
            tagId={tagReference.tag_id}
        />
    );

    const open = () => {
        reference.reference.open();
    }

    const referenceColor = reference.reference.isOnPageReference() ? '#57ce46' : '#3968d0';

    return (
        <Tooltip placement="topRight" title={tooltipContent} color="white"
                 overlayStyle={{maxWidth: '1800px', maxHeight: '2000px'}}
                 destroyTooltipOnHide={true}
        >
            <a onClick={open}>
                <span style={{backgroundColor: referenceColor}} className="medium-circle"/>
                {tagReference.tag_number}
            </a>
        </Tooltip>
    );
}

const maxRefs = 4;

export default function ObjectReferencesV2Component({node, hierarchyView}: {
    node: HierarchyNode,
    hierarchyView: ViewHierarchy
}) {
    const [switchDrawingModalVisible, setSwitchDrawingModalVisible] = useState(false);
    const [refs, setRefs] = useState<ObjectReferenceWithExtraData[]>([]);

    const nodeRefsDataSource = useMemo<AsyncDataSource>(
        () => node.getRefsWithExtraDataSource(false),
        [node]
    );

    const isLoading = useFetchWithLoading(
        () => nodeRefsDataSource.values(1, maxRefs),
        result => {
            setRefs(result);
        },
        empty,
        [nodeRefsDataSource]
    );

    const refsToShow = refs.slice(0, maxRefs);
    // const hasMoreRefs = refs.length > maxRefs;

    const showAllRefs = () => {
        setSwitchDrawingModalVisible(true);
    };

    return (
        <>
            <Spin spinning={isLoading}>
                <Space direction="vertical">
                    {refsToShow.length === 0 && (
                        "<empty>"
                    )}
                    {refsToShow.map(x => (
                        <ObjectReferenceV2Component
                            reference={x}
                            node={node}
                            hierarchyView={hierarchyView}
                        />
                    ))}

                    {refsToShow.length !== 0 &&(
                        <a onClick={showAllRefs}>table view</a>
                    )}
                </Space>
            </Spin>
            <SelectReferenceToGoModal
                key={node.id}
                dataSource={nodeRefsDataSource}
                visible={switchDrawingModalVisible}
                onVisibleChange={val => setSwitchDrawingModalVisible(val)}
            />
        </>
    );
}
